/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ShareNetworkIcon20Solid = forwardRef('ShareNetworkIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M17.25 5a3.25 3.25 0 0 1-5.44 2.402L8.21 9.46a3.271 3.271 0 0 1 0 1.08l3.601 2.057a3.25 3.25 0 1 1-.993 1.736l-3.53-2.017a3.25 3.25 0 1 1-.006-4.63l3.536-2.02A3.25 3.25 0 1 1 17.25 5Z" })));
});
